import { render, staticRenderFns } from "./JobListingTerm.vue?vue&type=template&id=af999a08&"
import script from "./JobListingTerm.vue?vue&type=script&lang=ts&"
export * from "./JobListingTerm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemActionText } from 'vuetify/lib/components/VList';
installComponents(component, {VCol,VIcon,VListItemActionText})
